import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.753 9.6a.749.749 0 0 1-.75.75h-6.03a.75.75 0 1 1 0-1.5H14a.743.743 0 0 1 .753.75Zm-2.79 2.65h-7.53a.75.75 0 0 0 0 1.5h7.53a.75.75 0 0 0 0-1.5ZM3 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1Zm7.57 2.2a.749.749 0 0 0-.75-.75h-7a.75.75 0 0 0 0 1.5h7a.749.749 0 0 0 .753-.75Z';
const draw24px =
  'M16.18,10H3.68a.75.75,0,1,1,0-1.5h12.5a.75.75,0,0,1,0,1.5Zm5.46,4.62a.75.75,0,0,0-.75-.75H12.25a.75.75,0,0,0,0,1.5h8.64A.74.74,0,0,0,21.64,14.62ZM18.71,20a.75.75,0,0,0-.75-.75H7.18a.75.75,0,0,0,0,1.5H18A.75.75,0,0,0,18.71,20ZM4.06,5.3A1.25,1.25,0,1,0,2.81,4.05,1.25,1.25,0,0,0,4.06,5.3Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ChartGanttIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'chartGantt'),
) as IconWithRender;

ChartGanttIcon.displayName = 'ChartGanttIcon';
ChartGanttIcon.propTypes = Icon.propTypes;
ChartGanttIcon.renderIcon = (props) => <ChartGanttIcon {...props} />;
export default ChartGanttIcon;
